"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoLinksItemStyled = exports.PhotoLinksGridStyled = exports.StyledBox = exports.CarouselWrapper = exports.ContainerStyled = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _const = require("@dbi-tools/ui-kit/lib/const");

var _helpers = require("../../helpers");

var _const2 = require("./const");

var _carousel = require("../carousel/carousel.styled");

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  text-align: center;\n  text-decoration: none;\n\n  &:hover {\n    ", " {\n      color: ", ";\n    }\n  }\n\n  ", " {\n    position: static;\n    padding-top: ", ";\n  }\n\n  img {\n    display: block;\n    width: 100%;\n    object-fit: cover;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 30px;\n  display: grid;\n  flex-wrap: wrap;\n  gap: ", "px;\n  ", "\n\n  ", " {\n    grid-template-columns: repeat(2, 1fr);\n    gap: ", "px;\n    row-gap: ", "px;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        height: ", "px;\n        top: ", "px;\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  ", ";\n\n  &:before {\n    ", ";\n    left: 0;\n    position: absolute;\n    width: 100%;\n    z-index: -1;\n  }\n\n  ", " {\n    padding: ", ";\n\n    ", " {\n      padding: 0 6px;\n\n      ", " {\n        .slick-slider {\n          padding: 0 41px;\n\n          .slick-control {\n            top: calc(50% - 15px);\n\n            &:first-child {\n              left: 5px;\n            }\n\n            &:last-child {\n              right: 5px;\n            }\n          }\n        }\n      }\n    }\n    ", " {\n      padding: 0 23px;\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 30px;\n\n  .slick-slide {\n    padding: 0 15px;\n  }\n\n  .slick-slider {\n    .slick-control {\n      top: calc(50% - 15px);\n\n      ", "\n\n      &:first-child {\n        left: -30px;\n      }\n\n      &:last-child {\n        right: -30px;\n      }\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ContainerStyled = (0, _uiKit.styled)(_uiKit.Container)(_templateObject());
exports.ContainerStyled = ContainerStyled;
var CarouselWrapper = (0, _uiKit.styled)('div')(_templateObject2(), _carousel.CarouselDefaultArrowStyles);
exports.CarouselWrapper = CarouselWrapper;
var StyledBox = (0, _uiKit.styled)(_uiKit.Box)(_templateObject3(), function (_ref) {
  var $theme = _ref.theme.$theme;
  return $theme && (0, _helpers.getTheme)($theme);
}, function (_ref2) {
  var _ref2$theme = _ref2.theme,
      $backDropSize = _ref2$theme.$backDropSize,
      $backDropOffset = _ref2$theme.$backDropOffset;
  return $backDropSize && (0, _uiKit.css)(_templateObject4(), $backDropSize, $backDropOffset);
}, ContainerStyled, function (_ref3) {
  var $type = _ref3.theme.$type;
  return $type === _const2.PhotoLinksView.CAROUSEL ? "0 12px;" : "0 27px";
}, _const.GridBreakpointsMediaDown.lg, CarouselWrapper, _const.GridBreakpointsMediaDown.md);
exports.StyledBox = StyledBox;
var PhotoLinksGridStyled = (0, _uiKit.styled)('div')(_templateObject5(), _const2.DEFAULT_GAP, function (_ref4) {
  var columnNumber = _ref4.columnNumber;
  return "grid-template-columns: repeat(".concat(columnNumber, ", 1fr);");
}, _const.GridBreakpointsMediaDown.md, _const2.MOBILE_GAP, _const2.DEFAULT_GAP);
exports.PhotoLinksGridStyled = PhotoLinksGridStyled;
var PhotoLinksItemStyled = (0, _uiKit.styled)('a')(_templateObject6(), _uiKit.TextStyled, function (_ref5) {
  var isDarkTheme = _ref5.isDarkTheme;
  return isDarkTheme ? _uiKit.Colors.gray300 : _uiKit.Colors.wine;
}, _uiKit.LoadingBlockStyled, function (_ref6) {
  var height = _ref6.height;
  return height ? "".concat(height, "px") : '0px';
});
exports.PhotoLinksItemStyled = PhotoLinksItemStyled;